import { createSelector } from 'reselect';

export const getGyms = (state) => state.gyms;
export const isGymsLoading = createSelector(getGyms, (gyms) => gyms.loading);
export const getGymsError = createSelector(getGyms, (gyms) => gyms.error);
export const getGymsItems = createSelector(getGyms, (gyms) => gyms.items);
export const getGymItem = createSelector(getGyms, (gyms) => gyms.item);
